import { runApiCall } from './api-config';

export async function list() {
    const res = await runApiCall('GET', 'users/');
    return res.data;
}